import React, { useCallback, useEffect, useRef } from 'react'
import { matchPath } from 'react-router-dom'
import { subscribe } from 'react-contextual'
import { FocusMode } from '../../../../views/components'
import PropertiesProvider from '../../PropertiesProvider'
import EditPropertyForm from './EditPropertyForm'
import { useSelector } from 'react-redux'
import { userApiSelectors } from 'modules/api/user'

const EditProperty = ({
  id,
  currentProperty,
  match,
  goBack,
  fetchProperty,
  initialValuesForEdit,
  updateCurrentProperty,
}: any) => {
  // Fetch at most once per id. If the request fails (e.g. 404 for a property that no
  // longer exists) currentProperty stays undefined; without this guard every re-render
  // would issue another request and hammer the API.
  const requestedId = useRef<string | undefined>(undefined)
  useEffect(() => {
    if (!currentProperty && id && requestedId.current !== id) {
      requestedId.current = id
      fetchProperty(id)
    }
  }, [id, currentProperty, fetchProperty])

  const isReadOnly = useSelector(userApiSelectors.isReadOnlyRole)

  const handleSubmit = useCallback(
    (values: any): void => {
      updateCurrentProperty(values)
      goBack()
    },
    [updateCurrentProperty, goBack],
  )

  const FormContent = useCallback(
    () => (
      <EditPropertyForm
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ initialValues: any; handleSubmit: (values:... Remove this comment to see the full error message
        initialValues={initialValuesForEdit}
        handleSubmit={handleSubmit}
        onCancel={goBack}
        isReadOnly={isReadOnly}
      />
    ),
    [initialValuesForEdit, handleSubmit, goBack, isReadOnly],
  )

  if (!currentProperty) {
    return null
  }

  const editMatchPath = matchPath(match.url, {
    path: '/properties/:id([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/edit',
    exact: true,
    strict: false,
  })

  return (
    <FocusMode isOpen={editMatchPath !== null} title="Edit Property" ContentComponent={FormContent} onClose={goBack} />
  )
}

export default subscribe(
  PropertiesProvider,
  ({
    match,
    currentProperty,
    propertyViewId,
    goBack,
    fetchProperty,
    initialValuesForEdit,
    updateCurrentProperty,
  }: any) => ({
    match,
    currentProperty,
    id: propertyViewId,
    goBack,
    fetchProperty,
    initialValuesForEdit,
    updateCurrentProperty,
  }),
)(EditProperty)
